var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.037 568.238a23.322 23.322 0 0 1-23.291-23.301 23.327 23.327 0 0 1 23.29-23.301h301.922a23.322 23.322 0 0 1 23.301 23.301 23.322 23.322 0 0 1-23.3 23.301H361.036z m0-110.664a23.322 23.322 0 0 1-23.296-23.296 23.322 23.322 0 0 1 23.296-23.296h226.14a23.322 23.322 0 0 1 23.29 23.291 23.322 23.322 0 0 1-23.29 23.296l-226.14 0.005z m0-116.674a23.322 23.322 0 0 1-23.291-23.291 23.322 23.322 0 0 1 23.29-23.29h301.922a23.316 23.316 0 0 1 23.291 23.29 23.316 23.316 0 0 1-23.29 23.29H361.036z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.642 888.883c-43.699 0-79.247-35.553-79.247-79.252V212.89c0-43.7 35.548-79.248 79.247-79.248h469.586c43.694 0 79.248 35.554 79.248 79.253v476.723a26.143 26.143 0 0 1-5.607 16.123L684.227 878.956a25.887 25.887 0 0 1-20.445 9.927h-386.14z m-0.005-703.14a27.208 27.208 0 0 0-27.136 27.136v596.752a27.203 27.203 0 0 0 27.136 27.14h343.137V730.436c0-43.695 35.549-79.248 79.248-79.248h74.347V212.89a27.213 27.213 0 0 0-27.14-27.142H277.636zM700.017 703.3a27.197 27.197 0 0 0-27.131 27.125v78.792l83.548-105.917h-56.417z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.2ba83109f4af5612ccd5faa67587c398.svg";
export { ForwardRef as ReactComponent };